import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import ActiveControl from '../../../../components/ActiveControl';
import { SurveyDataForm, SurveyFilters } from '../../../../app/models/Survey';
import SurveySwitchChange from '../SurveySwitchChange';
import SurveyFilter from './SurveyFilter';
import circleRed from '../../../../assets/images/icons/circle-color-red.svg';
import circleYellow from '../../../../assets/images/icons/circle-color-yellow.svg';
import circleGreen from '../../../../assets/images/icons/circle-color-green.svg';
import SurveyMandatorySwitchChange from '../SurveyMandatorySwitchChange';

interface Props {
    surveys: SurveyDataForm[];
    totalRows: number;
    loading?: boolean;
    hideActive?: boolean;
    edit?: (id: number) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    showResponses?: (id: number) => void;
    filter: SurveyFilters;
    setFilter: (filter: SurveyFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
    onSearch: () => void;
    isShow?: boolean
}

const SurveyDataTable = ({
    surveys,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    hideActive = false,
    showResponses,
    filter,
    setFilter,
    callbackSuccess,
    onSearch,
    isShow = true
}: Props) => {
    const columns = [
        {
            name: 'ID',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: SurveyDataForm, index: any, column: any) => (
                <span className="">{row.id}</span>
            )
        },
        {
            name: 'Título',
            selector: (row: any) => row.title,
            sortable: true,
            sortField: 'title',
            cell: (row: SurveyDataForm, index: any, column: any) => (
                <span className="">{row.title}</span>
            )
        },
        {
            name: 'Obligatorio',
            selector: (row: any) => row?.is_mandatory,
            sortable: true,
            sortField: 'is_mandatory',
            cell: (row: SurveyDataForm, index: any, column: any) => (
                <SurveyMandatorySwitchChange
                    checkValue={row.is_mandatory ?? true}
                    surveyId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Activo',
            selector: (row: any) => row?.is_active,
            sortable: true,
            sortField: 'is_active',
            omit: hideActive,
            cell: (row: SurveyDataForm, index: any, column: any) => (
                <SurveySwitchChange
                    checkValue={row.is_active ?? true}
                    surveyId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Estado',
            selector: (row: any) => row?.status,
            sortable: false,
            sortField: 'status',
            omit: isShow,
            cell: (row: any, index: any, column: any) => {

                let _color = circleRed;
                let _status = 'Pendiente'

                if (row.user_response_data?.state === 'IN_PROGRESS') {
                    _color = circleYellow;
                    _status = 'En curso'
                } else if (row.user_response_data?.state === 'COMPLETED') {
                    _color = circleGreen;
                    _status = 'Completada'
                }

                return (
                    <span className="">
                        <img
                            src={_color}
                            alt="circle"
                            style={{
                                width: '25px',
                                height: '25px',
                                marginRight: '5px',
                                marginBottom: '3px'
                            }}
                        />
                        {_status}
                    </span>
                );
            }
        },
        {
            name: 'Acciones',
            selector: (row: any) => row?.id,
            sortable: false,
            width: '150px',
            omit: !show && !showResponses && !edit && !destroy,
            cell: (row: SurveyDataForm, index: any, column: any) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row?.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {showResponses && (
                        <ButtonTableAction
                            callbackFunction={() => showResponses(row?.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver Respuestas'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row?.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row?.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];
    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <SurveyFilter filter={filter} setFilter={setFilter} onSearch={onSearch}/>
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={surveys}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default SurveyDataTable;
